export default "__VITE_ASSET__fbHNdyPV__"